export default [{
                              fontFamily: 'Inter-Light',
                              file: require('/app/appConfigs/base/fonts/Inter-Light.ttf'),
                          },];